import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UploadManagerService } from './upload-manager.service';
import { AutoSubOnDestroy, AutoSub } from '../../providers';
import { MediaType, CacheProgress, ResourceStatus } from '../../models';

const AUTO_CLOSE_SEC: number = 5;

interface UploadItem {
    url: string;
    mediaType: MediaType;
    percentage: number;
    message: string;
    status: ResourceStatus;
}

@AutoSubOnDestroy()
@Component({
    selector: 'upload-manager',
    templateUrl: './upload-manager.component.html',
    styleUrls: ['./upload-manager.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class UploadManagerComponent implements OnInit {

    @Output() uploadDone = new EventEmitter<CacheProgress>();

    public showManager: boolean = false;
    public hideDetails: boolean = true;
    public totalProgress: number = 100;
    public uploadArray: UploadItem[] = [];

    private closeTimer = null;

    // Expose type to view
    public MediaType = MediaType;

    constructor(public uploadManagerService: UploadManagerService) {
    }

    ngOnInit() {
        AutoSub(this).reg['progressSub'] = this.uploadManagerService.watchUploadProgress().subscribe(ev => {
            this.totalProgress = ev.totalPct;
            this.showManager = true;

            if(this.totalProgress >= 100) {
                this.uploadDone.emit(ev);
                this.cancelClose();

                this.closeTimer = setTimeout(() => {
                    this.showManager = false;
                    this.closeTimer = null;
                }, AUTO_CLOSE_SEC * 1000);
            }

            this.updateUploadArray();
        });
    }

    updateUploadArray() {
        this.uploadArray = Object.keys(this.uploadManagerService.uploadMap).map((key) => {
            const uploadItem = this.uploadManagerService.uploadMap[key];
            const status = uploadItem.observer.lastVal.status;
            let percentage = uploadItem.observer.lastVal.percentage;
            let message = `Uploading (${percentage.toFixed(0)}%)`;

            if(percentage >= 100) {
                message = 'Completed (100%)';
            }

            if(status == 'Error') {
                percentage = 100;
                message = 'Failed';
            }

            return {
                url: uploadItem.file.url,
                mediaType: uploadItem.file.mediaType,
                percentage,
                message,
                status,
            };
        });
    }

    private cancelClose() {
        if(!this.closeTimer) return;

        clearTimeout(this.closeTimer);
        this.closeTimer = null;
    }

    public toggleDetails() {
        this.cancelClose();
        this.hideDetails = !this.hideDetails;
    }

    public closeManager(ev: Event) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        this.uploadManagerService.clearUploadList();
        this.showManager = false;
        this.cancelClose();
    }
}
